module.exports = __webpack_public_path__ + "static/Icons_Refinance_large-44875c64c04fe217fe14ae652be1c4bf.png";